import React, { useState, useEffect } from "react";

export default function Categories({
  categories,
  checkedCategories,
  setCheckedCategories,
  categoryLevel
}) {
  const [searchFiltersQuery, setSearchFiltersQuery] = useState("");
  const [filteredCategories, setFilteredCategories] = useState(categories);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedTopLevel, setSelectedTopLevel] = useState(null);

  const handleTopCatSelection = (category) => {
    setSelectedTopLevel(category);
  };

  const handleCheckbox = (obj) => {
    const isChecked = checkedCategories.find((c) => c.id === obj.id);
    if (!isChecked) {
      setCheckedCategories([obj, ...checkedCategories]);
    } else {
      setCheckedCategories(checkedCategories.filter((c) => c.id !== obj.id));
    }
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const newCheckedCategories = checked
      ? categories?.map((category) => ({
          id: category.id,
          name: category.name,
          sub_categories: category.sub_categories
        }))
      : [];
    setCheckedCategories(newCheckedCategories);
    setSelectAllChecked(checked);
  };

  useEffect(() => {
    setFilteredCategories(
      categories?.filter((c) =>
        c.name.toLowerCase().includes(searchFiltersQuery.toLowerCase())
      )
    );

    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const numChecked = checkedCategories.length;
    setSelectAllChecked(numChecked === categories?.length);

    checkboxes.forEach((checkbox) => {
      const isChecked = checkedCategories.find((c) => c.name === checkbox.name);
      checkbox.checked = !!isChecked;
    });
  }, [categories, checkedCategories, searchFiltersQuery]);

  const selectedTopSubcategories = selectedTopLevel
    ? categories.find((c) => c.id === selectedTopLevel.id).sub_categories
    : [];

  return categories && categoryLevel === 'Top' ? (
    <div className="content-container">
      <div className="cat-check">
        <div className="select-all-cat">
          <input
            type="checkbox"
            checked={selectAllChecked}
            onChange={handleSelectAll}
          />
          {selectAllChecked ? (
            <label>Uncheck all</label>
          ) : (
            <label>Check all</label>
          )}
        </div>
        <ul>
          {filteredCategories?.map((category) => (
            <li key={category.id}>
              <span
                onClick={() => {
                  handleCheckbox(category);
                }}
              >
                <input
                  checked={checkedCategories.find((c) => c.id === category.id)}
                  type="checkbox"
                  onChange={() => {
                    handleCheckbox(category);
                  }}
                  name={category.name}
                  key={category.id}
                />
                <label>{category.name}</label>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : categoryLevel === 'Sub' ? (
    <div className="content-container">
      <div className="cat-check">
        <div className="cat-subchecklist">
          <div className="selected-top-categories">
            {checkedCategories?.map((category) => (
              category.sub_categories ?
              <li key={category.id}>
                <button onClick={() => handleTopCatSelection(category)}>
                  {category.name}
                </button>
              </li>
              : ''
            ))}
          </div>
          <div className="sub-category-selection">
            {selectedTopLevel && (
              <>
                <h2 style={{ float: "left" }}>{selectedTopLevel.name}</h2>
                <ul>
                  {selectedTopSubcategories?.map((subCategory) => (
                    <li key={subCategory.id}>
                      <span
                        onClick={() => {
                          handleCheckbox(subCategory);
                        }}
                      >
                        <input
                          checked={checkedCategories.find(
                            (s) => s.id === subCategory.id
                          )}
                          type="checkbox"
                          onChange={() => {
                            handleCheckbox(subCategory);
                          }}
                          name={subCategory.name}
                          key={subCategory.id}
                        />
                        <label>{subCategory.name}</label>
                      </span>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
